export const OPEN_BUTTON_TEXT = 'REQUISITIONLIST_ADD_NEW';

export const KEBAB_OPTIONS = {
  ADD_TO_CART: 'addToCart',
  MARK_FAVORITE: 'markFavorite',
  REMOVE_FAVORITE: 'removeFavorite',
  DUPLICATE_LIST: 'duplicateList',
  SHARED_LIST: 'sharedlist',
  DELETE_LIST: 'deleteList'
};

export const GENERIC_ERROR = 'GENERIC_ERROR';
export const DATE_FORMAT_YYYY_MM_DD = 'yyyy-MM-dd';
export const DATE_FORMAT_MM_DD_YY = 'MM/dd/yy';
export const SAVED_LIST = 'SavedList';
export const INDEX = 'INDEX';

export const SAVED_LIST_ACTIONS = {
  DELETE: 'delete',
  ADD: 'add',
  REMOVE_AS_FAVORITE: 'removeAsFavorite',
  ADD_AS_FAVORITE: 'addAsFavorite'
};

export const SAVED_LIST_MANAGE_VIEW_FIELDS = {
  SHOW_MY_FAVS: 'showOnlyMyFavorites',
  SHOW_MY_LISTS: 'showOnlyMyLists'
};

export const PAGE_LIMIT = 12;
export const PAGE_SIZE_OPTIONS = [12, 24, 48, 96];

export const SEARCH_TERM = 'searchTerm';

export const SAVED_LIST_DEFAULT_MANAGE_VIEW_PREFERENCES = {
  defaultShowOnlyMyFavorites: false,
  defaultShowOnlyMyLists: true
};

export const SAVED_LIST_SHOW_ONLY_MY_LIST = 'savedList_showOnlyMyList';
export const SAVED_LIST_SHOW_ONLY_MY_FAVORITES =
  'savedList_showOnlyMyFavorites';

export const SAVED_LIST_USER_ATTRIBUTES_TO_MANAGE = [
  SAVED_LIST_SHOW_ONLY_MY_LIST,
  SAVED_LIST_SHOW_ONLY_MY_FAVORITES
];

export const LIST_SETTINGS_DRAWER_FIELDS = {
  LIST_NAME: 'folName' as const,
  LIST_TYPE: 'listType' as const,
  EQUIPMENT: 'equipment' as const
};

export const STATUS_ERROR = 'error';

export const IMAGE_DIMENSIONS = {
  DESKTOP_IMAGE_DIMENSION: 32,
  MOBILE_IMAGE_DIMENSION: 48
};

export const INCREMENT_VALUE = +1;
export const DECREMENT_VALUE = -1;
export const NUMERIC_VALUE_ONE = 1;

export const EQUIPMENT_FIELDS_ID = {
  SERIAL_NUMBER: 'serialNumber',
  ASSET_ID: 'assetId',
  MODEL: 'model'
};

export const MILLISECONDS_DEBOUNCE_LIST_ITEM_QUANTITY = 500;
export const QO_FORM_COL_WIDTH_ICON = '37px';
export const QO_FORM_COL_WIDTH_QUANTITY = '105px';
export const DEFAULT_DISPLAY_NOTES_VALUES = {
  showCustomerPartNumber: true,
  showEquipmentNumber: true,
  showLineItemNote: true,
  showCustomerItemNumber: true
};
export const ITEMSFIELDNAME = 'items';
export const ADD_ITEM_FORM_ID = 'add-items-form';

export const NUMBER_REGEX = '^\\d+$';
export const FIELDS_MAX_LENGTH = {
  note: 50,
  serialNumber: 20,
  customerItemNumber: 5,
  customerPartNumber: 20
};

export const NOTES_KEBAB_MENU = {
  EDIT_NOTES: 'editNotes',
  STOP_EDITING: 'stopEditing'
};

export const MOBILE_VIEW_KEBAB_MENU = {
  EDIT_ITEM: 'editItem',
  DELETE: 'delete'
};
export const EDIT_ACTION = 'edit';
export const ACCORDIAN_ACTION = 'accordian';
export const CANCEL_ACTION = 'cancel';
export const LIST_EXPORT_DATE_FORMAT = 'dd/MM/yyyy';
